// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__3ed4P","title":"hero_title__fRhS6","arrow":"hero_arrow__13rwu","copy":"hero_copy__zbBnL"};